import { gsap, ScrollTrigger } from './gsap';

const staggerReveal = () => {
  const staggerItems = gsap.utils.toArray('.stagger-reveal > *, .wpforms-field-container > div, .wpforms-submit-container .cta-btn');

  if (staggerItems.length > 0) {
    const defaults = { ease: 'expo', duration: 1.25, overwrite: true };
    gsap.set(staggerItems, { y: 100 });

    ScrollTrigger.batch(staggerItems, {
      onEnter: (batch) => gsap.to(batch, {
        ...defaults,
        autoAlpha: 1,
        y: 0,
        stagger: 0.15,
      }),
      onLeave: (batch) => gsap.set(batch, {
        ...defaults,
        autoAlpha: 0,
        y: -100,
      }),
      onEnterBack: (batch) => gsap.to(batch, {
        ...defaults,
        autoAlpha: 1,
        y: 0,
        stagger: 0.15,
      }),
      onLeaveBack: (batch) => gsap.set(batch, {
        ...defaults,
        autoAlpha: 0,
        y: 100,
      })
    });

    ScrollTrigger.addEventListener('refreshInit', () => gsap.set(staggerItems, { y: 0 }));
  }
};

export default staggerReveal;
